import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axiosInstance from '../axios/axiosConfig';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [ready, setReady] = useState(false);
    const [userRole, setUserRole] = useState(null);

    const checkAuth = useCallback(async () => {
        try {
            const { data } = await axiosInstance.get('/auth/current-user');
            setIsLoggedIn(true);
            setUserRole(data?.user?.role || null);
            return data?.user || null;
        } catch {
            setIsLoggedIn(false);
            setUserRole(null);
            return null;
        } finally {
            setReady(true);
        }
    }, []);

    useEffect(() => {
        checkAuth();
    }, [checkAuth]);

    const login = useCallback(async () => {
        setIsLoggedIn(true);
        return checkAuth();
    }, [checkAuth]);

    const logout = useCallback(async () => {
        try {
            await axiosInstance.post('/auth/logout');
        } catch {}
        setIsLoggedIn(false);
        setUserRole(null);
    }, []);

    return (
        <AuthContext.Provider value={{ isLoggedIn, ready, userRole, login, logout, checkAuth }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
